import React, { createContext, useContext, useEffect, useState } from "react";
import { registerUser, loginUser, getMe } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("cs_token") || "");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!token) { setReady(true); return; }
    getMe(token)
      .then((u) => setUser(u))
      .catch(() => { localStorage.removeItem("cs_token"); setToken(""); })
      .finally(() => setReady(true));
  }, [token]);

  const persist = (data) => {
    localStorage.setItem("cs_token", data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => persist(await registerUser(payload));
  const login = async (payload) => persist(await loginUser(payload));
  const logout = () => { localStorage.removeItem("cs_token"); setToken(""); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, ready, register, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
